import configs from "@/config/config.js";
import require from "./require";
const state = () => ({
  userInfo: {},
  tipMsg: {
    show: false,
    msg: ""
  }
});
const mutations = {
  setUserInfo(state, userInfo) {
    if (userInfo.id) {
      localStorage.setItem("bipids", userInfo.id);
      let obj = {
        ...userInfo,
        userId: userInfo.id
      };
      state.userInfo = obj;
    } else {
      localStorage.setItem("bipids", userInfo.userId);
      state.userInfo = userInfo;
    }
  },
  setTipMsg(state, tipMsg) {
    state.tipMsg = tipMsg;
  }
};
function NewData(data) {
  var d = new Date(data);
  var year = d.getFullYear(); //年
  var month = d.getMonth() + 1; //月
  var day = d.getDate(); //日
  var hh = d.getHours(); //时
  var mm = d.getMinutes(); //分
  var ss = d.getSeconds(); //秒
  var clock = year + "-";
  if (month < 10) clock += "0";
  clock += month + "-";
  if (day < 10) clock += "0";
  clock += day + " ";
  if (hh < 10) clock += "0";
  clock += hh + ":";
  if (mm < 10) clock += "0";
  clock += mm + ":";
  if (ss < 10) clock += "0";
  clock += ss;
  return clock;
}

//配置
const config = {
  tipMessage({ commit, dispatch }, { context }) {
    const tmsg = {
      show: true,
      msg: context
    };
    commit("setTipMsg", tmsg);

    setTimeout(() => {
      commit("setTipMsg", {
        ...tmsg,
        show: false
      });
    }, 2000);
  },
  async getAchievementList(
    { commit, dispatch },
    { $axios, reload = false, ...postData }
  ) {
    $axios.setToken(localStorage.getItem("Bearer") || "", "Bearer");
    const res = await require.mypost(
      $axios,
      `${tgaPlatformSDK.data.apiBaseHost}/tga/Config/GetAchievementList`,
      {
        token: localStorage.getItem("Bearer") || "none"
      }
    );
    console.log("GetAchievementList", res);
    const clist = res.data.Data;
    if (clist && clist.length > 0) {
      const res_u = await require.mypost(
        $axios,
        `${tgaPlatformSDK.data.apiBaseHost}/tga/User/GetUserAchievement`,
        {
          token: localStorage.getItem("Bearer") || "none"
        }
      );
      const udata = res_u.data.Data || [];

      clist.forEach(c => {
        c.Status = 0;
        c.UpdateTime = NewData(c.UpdateTime);
        const uac = udata.find(o => o.AchievementId == c.Id);
        if (uac) {
          c.Status = uac.Status;
        }
      });
    }
    console.log("GetUserAchievement", clist);
    return clist || [];
  },
  async updateUserAchievement(
    { commit, dispatch },
    { $axios, reload = false, ...postData }
  ) {
    $axios.setToken(localStorage.getItem("Bearer") || "", "Bearer");
    const res = await require.mypost(
      $axios,
      `${tgaPlatformSDK.data.apiBaseHost}/tga/User/UpdateUserAchievement`,
      { ...postData, token: localStorage.getItem("Bearer") || "none" }
    );
    const clist = res.data.Data;
    console.log("UpdateUserAchievement", res);
  }
};

//用户
const user = {
  // 在登录之前 获取该页面默认语言
  async DLang(
    { state, commit, dispatch },
    { $axios, reload = false, ...postData }
  ) {
    const res = await $axios.post(
      `${tgaPlatformSDK.data.apiBaseHost}/tga/User/DLang`,
      {
        // ...postData
      }
    );

    var lang = postData.lang;
    if (lang) {
      if (lang.toLowerCase() == "en") {
        localStorage.setItem("lang", lang);
      } else if (lang.toLowerCase() == "tr") {
        localStorage.setItem("lang", lang);
      } else {
        lang = res.data.resultInfo.lang.toLowerCase();
        localStorage.setItem("lang", lang);
      }
    } else {
      if (localStorage.getItem("lang")) {
        console.log("localStorage lang null");
        lang = localStorage.getItem("lang");
      } else {
        lang = res.data.resultInfo.lang.toLowerCase();
      }
      localStorage.setItem("lang", lang);
    }

    localStorage.setItem("tacitlyLang", res.data.resultInfo.lang.toLowerCase());
    // commit("setlang",lang);
    return res.data;
  },
  // 保存用户头像昵称
  async UpdateUserInfo(
    { state, commit, dispatch },
    { $axios, reload = false, ...postData }
  ) {
    $axios.setToken(localStorage.getItem("Bearer") || "", "Bearer");

    const res = await require.mypost(
      $axios,
      `${tgaPlatformSDK.data.apiBaseHost}/tgadpUser/UpdateUserInfo`,
      {
        ...postData
      }
    );
    // try{
    // 	 require.mypost($axios,"/sb/tgadpUser/UpdateUserInfo", {
    // 	  ...postData,
    // 	});
    // }catch(e){
    // }

    console.log("UpdateUserInfo", res);

    return res.data;
  },

  // 获取地址
  async GetLink(
    { state, commit, dispatch },
    { $axios, reload = false, ...postData }
  ) {
    $axios.setToken(localStorage.getItem("Bearer") || "", "Bearer");

    const res = await require.mypost(
      $axios,
      `${tgaPlatformSDK.data.apiBaseHost}/tga/bip/GetLink`,
      {
        ...postData
      }
    );
    console.log("GetLink", res);

    return res.data;
  },
  // 提交地址
  async CommitLink(
    { state, commit, dispatch },
    { $axios, reload = false, ...postData }
  ) {
    $axios.setToken(localStorage.getItem("Bearer") || "", "Bearer");

    const res = await require.mypost(
      $axios,
      `${tgaPlatformSDK.data.apiBaseHost}/tga/bip/CommitLink`,
      {
        ...postData
      }
    );
    console.log("GetLink", res);

    return res.data;
  },

  // 获取用户信息

  async userInfo(
    { state, commit, dispatch },
    { $axios, reload = false, ...postData }
  ) {
    const res = await require.mypost(
      $axios,
      `${tgaPlatformSDK.data.apiBaseHost}/tgadpUser/Info`,
      {
        ...postData
      }
    );
    console.log("Info", res);
    if (res.data.stateCode == 1) {
      commit("setUserInfo", res.data.resultInfo.user);
    }
    // const res = await $axios.post(`${tgaPlatformSDK.data.apiBaseHost}/tgadpUser/TPLogin`, {
    //   type: 13,
    //   appId: configs.bipAppId(),
    //   txnId: localStorage.getItem('msisdn'),
    //   fpId: localStorage.getItem('msisdn'),
    //   nickname: localStorage.getItem('nickname')
    // })
    // console.log('BipLogin', res)
    // if (res.data.stateCode == 1) {
    //   localStorage.setItem(res.data.resultInfo.tokenType, res.data.resultInfo.accessToken);
    //   localStorage.setItem("refreshToken", res.data.resultInfo.refreshToken);
    //   commit("setUserInfo", res.data.resultInfo.user);
    // }
    // return res
  },

  async BipLogin(
    { state, commit, dispatch },
    { $axios, reload = false, ...postData }
  ) {
    commit("setUserInfo", postData);
    // const res = await $axios.post("/sb/tga/User/BipLogin",{
    //   ...postData
    // })
    // const res = await $axios.post(`${tgaPlatformSDK.data.apiBaseHost}/tgadpUser/TPLogin`, {
    //   type: 13,
    //   appId: configs.bipAppId(),
    //   txnId: localStorage.getItem('msisdn'),
    //   fpId: localStorage.getItem('msisdn'),
    //   nickname: localStorage.getItem('nickname')
    // })
    // console.log('BipLogin', res)
    // if (res.data.stateCode == 1) {
    //   localStorage.setItem(res.data.resultInfo.tokenType, res.data.resultInfo.accessToken);
    //   localStorage.setItem("refreshToken", res.data.resultInfo.refreshToken);
    //   commit("setUserInfo", res.data.resultInfo.user);
    // }
    // return res
  },

  // 点击参与活动
  async UserJoinAction(
    { state, commit, dispatch },
    { $axios, reload = false, ...postData }
  ) {
    $axios.setToken(localStorage.getItem("Bearer") || "", "Bearer");

    const res = await require.mypost(
      $axios,
      `${tgaPlatformSDK.data.apiBaseHost}/tga/bip/UserJoinAction`,
      {
        ...postData
      }
    );
    return res;
  },

  // 打开页面就签到
  async UserFinishTask(
    { state, commit, dispatch },
    { $axios, reload = false, ...postData }
  ) {
    $axios.setToken(localStorage.getItem("Bearer") || "", "Bearer");

    const res = await require.mypost(
      $axios,
      `${tgaPlatformSDK.data.apiBaseHost}/tga/bip/UserFinishTask`,
      {
        ...postData
      }
    );
    console.log("UserFinishTask", res);

    return res;
  },

  // 这个是游戏分享接口
  async GetShareUrl(
    { commit, dispatch },
    { $axios, reload = false, ...postData }
  ) {
    console.log("postData", postData);
    const res = await require.mypost(
      $axios,
      `${tgaPlatformSDK.data.apiBaseHost}/tga/bip/GetShareUrl`,
      {
        ...postData
      }
    );
    console.log("GetShareUrl", res);
    return res;
  }
};

const actions = {
  ...config,
  ...user
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/vuex/modules/user.js